import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import * as tokens from "@shape-ds/tokens";

export const baseTheme = {
  components: {
    MuiCssBaseline: {
      styleOverrides: `
      @font-face {
        font-family: ${tokens.TYPOGRAPHY_FAMILY_NUNITO};
        font-style: normal;
        font-weight: ${tokens.TYPOGRAPHY_FONT_WEIGHT_REGULAR};
        src: url('https://fonts.googleapis.com/css2?family=Nunito+Sans:opsz@6..12&family=Roboto:wght@400;700&display=swap');
      }
      @font-face {
        font-family: ${tokens.TYPOGRAPHY_FAMILY_NUNITO};
        font-style: normal;
        font-weight: ${tokens.TYPOGRAPHY_FONT_WEIGHT_BOLD};
        src: url('https://fonts.googleapis.com/css2?family=Nunito+Sans:opsz,wght@6..12,700&family=Roboto:wght@400;700&display=swap');
      }
      @font-face {
        font-family: ${tokens.TYPOGRAPHY_FAMILY_ROBOTO};
        font-style: normal;
        font-weight: ${tokens.TYPOGRAPHY_FONT_WEIGHT_REGULAR};
        src: url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');
      }
      @font-face {
        font-family: ${tokens.TYPOGRAPHY_FAMILY_ROBOTO};
        font-style: normal;
        font-weight: ${tokens.TYPOGRAPHY_FONT_WEIGHT_BOLD};
        src: url('https://fonts.googleapis.com/css2?family=Roboto:wght@700&display=swap');
      }
        
    `,
    },
    MuiSnackbar: {
      styleOverrides: {
        root: {
          "@media (min-width: 600px)": {
            bottom: "2rem",
            left: "2rem",
          },
        },
      },
    },
    MuiAutocomplete: {
      sx: {
        ".MuiAutocomplete-root .MuiAutocomplete-inputRoot .MuiAutocomplete-input":
          {
            width: "100%",
          },
      },
      styleOverrides: {
        root: {
          width: "100%",
          "&.MuiAutocomplete-root .MuiInputBase-sizeSmall": {
            padding: "0.5rem 1rem",
          },
        },
        input: {
          width: "100%",
          "&.MuiAutocomplete-input.MuiInputBase-input": {
            width: "100%",
            padding: 0,
          },
        },
        popper: {
          "*": {
            fontSize: tokens.TYPOGRAPHY_SIZE_PARAGRAPH_SM,
          },
        },
      },
    },
    MuiAlert: {
      defaultProps: { variant: "filled", icon: false, sx: { width: "100%" } },
      styleOverrides: {
        filled: {
          padding: `${tokens.SPACING_MD} `,
          fontSize: tokens.TYPOGRAPHY_SIZE_PARAGRAPH_MD,
          maxWidth: "500px",
          minWidth: "400px",
          borderRadius: "8px",

          "&.MuiAlert-colorError": {
            backgroundColor: tokens.darkColors.RED_2,
          },
          "&.MuiAlert-colorWarning": {
            backgroundColor: tokens.darkColors.YELLOW_2,
          },
          "&.MuiAlert-colorSuccess": {
            backgroundColor: tokens.darkColors.GREEN_2,
          },
          ".MuiAlert-icon, .MuiAlert-icon svg": {
            padding: 0,
            height: "20px",
            width: "20px",
          },
          ".MuiAlert-icon": {
            marginRight: tokens.SPACING_SM,
          },
          ".MuiAlert-message": {
            padding: 0,
            fontFamily: tokens.TYPOGRAPHY_FAMILY_ROBOTO,
            color: tokens.darkColors.GRAY_7,
            fontSize: tokens.TYPOGRAPHY_SIZE_PARAGRAPH_MD,
          },
          ".MuiAlert-action": {
            marginRight: 0,
            padding: 0,
            ".MuiIconButton-root": {
              height: "20px",
              width: "20px",
              padding: 0,
              marginLeft: tokens.SPACING_MD,
            },
          },
        },
      },
    },
    MuiAlertTitle: {
      defaultProps: {
        sx: { fontWeight: tokens.TYPOGRAPHY_FONT_WEIGHT_BOLD },
      },
    },
    MuiButton: {
      defaultProps: { color: "primary" },
      styleOverrides: {
        root: {
          textTransform: "none",
          fontFamily: tokens.TYPOGRAPHY_FAMILY_ROBOTO,
          fontWeight: tokens.TYPOGRAPHY_FONT_WEIGHT_REGULAR,
          fontSize: tokens.TYPOGRAPHY_SIZE_PARAGRAPH_SM,
          lineHeight: tokens.TYPOGRAPHY_LINE_HEIGHT_PARAGRAPH_MD,
          height: tokens.SPACING_XL,
          boxShadow: "none",
          borderRadius: tokens.SPACING_SM,
          "&:hover": { boxShadow: "none" },
        },
      },
    },
    MuiCard: {
      defaultProps: {
        variant: "outlined",
        sx: { width: "100%" },
      },
      styleOverrides: {
        root: {
          borderRadius: tokens.SPACING_SM,
          padding: tokens.SPACING_MD,
          border: "none",
          color: tokens.darkColors.GRAY_7,
        },
      },
    },
    MuiCheckbox: {
      defaultProps: {
        size: "small",
        sx: {
          "&.Mui-checked": {
            color: tokens.darkColors.BLUE_1,
          },
          "&.MuiCheckbox-indeterminate": {
            color: tokens.darkColors.BLUE_1,
          },
        },
      },
    },
    MuiDialog: {
      defaultProps: {
        hideBackdrop: false,
        slotProps: {
          backdrop: {
            style: { backgroundColor: "rgba(0, 0, 0, 0.7)" },
          },
        },
      },
    },
    MuiDialogContent: {
      defaultProps: {
        sx: {
          fontSize: tokens.TYPOGRAPHY_SIZE_PARAGRAPH_MD,
        },
      },
    },
    MuiDialogTitle: {
      defaultProps: {
        sx: {
          padding: 0,
          paddingBottom: tokens.SPACING_MD,
          fontSize: tokens.TYPOGRAPHY_SIZE_TITLE_SM,
        },
      },
    },

    MuiFormControl: {
      defaultProps: {
        size: "small",
        fullWidth: false,
        sx: { minWidth: 100 },
      },
      styleOverrides: {
        root: {},
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          fontFamily: tokens.TYPOGRAPHY_FAMILY_ROBOTO,
          fontWeight: tokens.TYPOGRAPHY_FONT_WEIGHT_REGULAR,
          fontSize: tokens.TYPOGRAPHY_SIZE_PARAGRAPH_SM,
          lineHeight: tokens.TYPOGRAPHY_LINE_HEIGHT_PARAGRAPH_MD,
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          margin: "4px 0px 0px 2px",
          lineHeight: tokens.TYPOGRAPHY_LINE_HEIGHT_PARAGRAPH_XS,
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontFamily: tokens.TYPOGRAPHY_FAMILY_ROBOTO,
          fontWeight: tokens.TYPOGRAPHY_FONT_WEIGHT_REGULAR,
          fontSize: tokens.TYPOGRAPHY_SIZE_PARAGRAPH_SM,
          lineHeight: tokens.TYPOGRAPHY_LINE_HEIGHT_PARAGRAPH_MD,
          marginBottom: tokens.SPACING_SM,
          color: tokens.darkColors.GRAY_6,
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: tokens.darkColors.GRAY_6,
        },
      },
    },
    MuiInputBase: {
      defaultProps: {
        size: "small",
        sx: {
          "& fieldset": { border: "none" },
          borderRadius: tokens.SPACING_SM,
          boxSizing: "border-box",

          ".MuiSvgIcon-root": {
            fontSize: tokens.TYPOGRAPHY_SIZE_PARAGRAPH_LG,
          },
          "input:-webkit-autofill,input:-webkit-autofill:hover,input:-webkit-autofill:focus,input:-webkit-autofill:active":
            {
              "-webkit-box-shadow": `0 0 0px 1000px ${tokens.darkColors.GRAY_3} inset !important`,
            },
        },
      },
      styleOverrides: {
        root: {
          boxSizing: "border-box",

          height: tokens.SPACING_XL,
          lineHeight: tokens.TYPOGRAPHY_LINE_HEIGHT_PARAGRAPH_SM,
          padding: `7px ${tokens.SPACING_MD}`,
          paddingRight: "12px",
          display: "grid",
          gridAutoColumns: "auto",

          gridAutoFlow: "column",
          gap: tokens.SPACING_SM,
          "&.MuiInputBase-multiline": {
            height: `auto`,
          },
          ".MuiButtonBase-root": { marginRight: "0" },
          "&.Mui-readOnly, &.Mui-disabled": {
            backgroundColor: "rgba(255, 255, 255, 0.08)",
            border: `none`,
          },

          ".MuiInputAdornment-root": {
            color: tokens.darkColors.GRAY_6,
            height: "1rem",
            width: "1rem",
            margin: 0,
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            ".MuiSvgIcon-root": {
              width: "20px",
              height: "20px",
            },
          },
          "&.MuiInputBase-adornedEnd": {
            paddingRight: "12px",
            gridTemplateColumns: "1fr auto",
          },
          "&.MuiInputBase-adornedStart": {
            paddingLeft: tokens.SPACING_MD,
            gridTemplateColumns: "auto 1fr",
          },
        },

        input: {
          fontFamily: tokens.TYPOGRAPHY_FAMILY_ROBOTO,
          fontWeight: tokens.TYPOGRAPHY_FONT_WEIGHT_REGULAR,
          fontSize: tokens.TYPOGRAPHY_SIZE_PARAGRAPH_SM,
          lineHeight: tokens.TYPOGRAPHY_LINE_HEIGHT_PARAGRAPH_SM,
          height: tokens.TYPOGRAPHY_LINE_HEIGHT_PARAGRAPH_SM,
          boxSizing: "border-box",
          width: "100%",
          color: tokens.darkColors.GRAY_7,
          ".Mui-disabled": {
            color: tokens.darkColors.GRAY_6,
          },
          "&.MuiOutlinedInput-input": {
            padding: 0,
          },
          "&::placeholder": {
            opacity: 1,
            color: tokens.darkColors.GRAY_6,
          },

          ".MuiButtonBase-root": {
            padding: "0",
            marginRight: "0",
          },
        },
      },
    },

    MuiMenuItem: {
      styleOverrides: {
        root: { fontSize: tokens.TYPOGRAPHY_SIZE_PARAGRAPH_SM },
      },
    },
    MuiRadio: {
      defaultProps: {
        disableRipple: true,
        size: "small",
        sx: {
          fontSize: tokens.TYPOGRAPHY_SIZE_PARAGRAPH_MD,
          "& .MuiSvgIcon-root": {
            fontSize: tokens.TYPOGRAPHY_SIZE_PARAGRAPH_LG,
          },
        },
      },
    },
    MuiSelect: {
      defaultProps: {
        IconComponent: KeyboardArrowDownIcon,
        sx: {
          marginTop: "0px !important",
          cursor: "pointer",
          fontSize: tokens.TYPOGRAPHY_SIZE_PARAGRAPH_SM,
          ".MuiSvgIcon-root": {
            color: tokens.darkColors.GRAY_6,
            height: "20px",
            width: "20px",
            right: "10px",
            top: "calc(50% - 10px)",
            position: "absolute",
            pointerEvents: "none",
          },
        },
      },
      styleOverrides: {
        root: {
          fontSize: tokens.TYPOGRAPHY_SIZE_PARAGRAPH_SM,
        },
        select: {
          height: "14px",
          minHeight: "14px",
          ".MuiSelect-nativeInput": { height: "1rem" },
          "&.MuiOutlinedInput-root": {
            height: "14px",
            minHeight: "14px",
          },
          "&.MuiOutlinedInput-input": {
            paddingRight: "0rem",
          },
        },
      },
    },
    MuiSwitch: {
      defaultProps: {
        size: "small",
        sx: {
          color: "green !important",
          "& .MuiFormControlLabel-label": { color: "green !important" },
        },
      },
    },

    MuiTabs: {
      defaultProps: {
        sx: {
          "& .MuiTabs-indicator": { borderRadius: "8px", height: 4 },
          "& .MuiTab-root": {
            fontFamily: tokens.TYPOGRAPHY_FAMILY_NUNITO,
            textTransform: "unset",
            fontWeight: tokens.TYPOGRAPHY_FONT_WEIGHT_REGULAR,
            fontSize: tokens.TYPOGRAPHY_SIZE_TITLE_XS,
            lineHeight: tokens.TYPOGRAPHY_LINE_HEIGHT_PARAGRAPH_XS,
          },
        },
      },
    },

    MuiTextField: {
      defaultProps: { type: "text" },
      // styleOverrides: {
      //   color: tokens.darkColors.GRAY_7,
      // },
    },
    MuiTooltip: {
      defaultProps: { arrow: true, placement: "top" },
      styleOverrides: {
        tooltip: {
          padding: `${tokens.SPACING_SM} ${tokens.SPACING_MD}`,
          fontSize: tokens.TYPOGRAPHY_SIZE_PARAGRAPH_SM,
          lineHeight: tokens.TYPOGRAPHY_LINE_HEIGHT_PARAGRAPH_SM,
          boxShadow: "0px 2px 8px 0px #00000040",
        },
      },
    },
  },
  tokens: {
    spacing: {
      xs: tokens.SPACING_XS,
      sm: tokens.SPACING_SM,
      md: tokens.SPACING_MD,
      lg: tokens.SPACING_LG,
      xl: tokens.SPACING_XL,
    },
    typography: {
      size: {
        title: {
          xs: tokens.TYPOGRAPHY_SIZE_TITLE_XS,
          sm: tokens.TYPOGRAPHY_SIZE_TITLE_SM,
          md: tokens.TYPOGRAPHY_SIZE_TITLE_MD,
          lg: tokens.TYPOGRAPHY_SIZE_TITLE_LG,
          xl: tokens.TYPOGRAPHY_SIZE_TITLE_XL,
        },
        paragraph: {
          xs: tokens.TYPOGRAPHY_SIZE_PARAGRAPH_XS,
          sm: tokens.TYPOGRAPHY_SIZE_PARAGRAPH_SM,
          md: tokens.TYPOGRAPHY_SIZE_PARAGRAPH_MD,
          lg: tokens.TYPOGRAPHY_SIZE_PARAGRAPH_LG,
        },
      },
      lineHeight: {
        title: {
          xs: tokens.TYPOGRAPHY_LINE_HEIGHT_TITLE_XS,
          sm: tokens.TYPOGRAPHY_LINE_HEIGHT_TITLE_SM,
          md: tokens.TYPOGRAPHY_LINE_HEIGHT_TITLE_MD,
          lg: tokens.TYPOGRAPHY_LINE_HEIGHT_TITLE_LG,
          xl: tokens.TYPOGRAPHY_LINE_HEIGHT_TITLE_XL,
        },
        paragraph: {
          xs: tokens.TYPOGRAPHY_LINE_HEIGHT_PARAGRAPH_XS,
          sm: tokens.TYPOGRAPHY_LINE_HEIGHT_PARAGRAPH_SM,
          md: tokens.TYPOGRAPHY_LINE_HEIGHT_PARAGRAPH_MD,
          lg: tokens.TYPOGRAPHY_LINE_HEIGHT_PARAGRAPH_LG,
        },
      },
      weight: {
        regular: tokens.TYPOGRAPHY_FONT_WEIGHT_REGULAR,
        bold: tokens.TYPOGRAPHY_FONT_WEIGHT_BOLD,
      },
    },
  },
};

declare module "@mui/material/styles" {
  interface Theme {
    shapeTheme: string;
    tokens: {
      colors: {
        blue: { "1": string; "2": string; "3": string; "4": string };
        gray: {
          "1": string;
          "2": string;
          "3": string;
          "4": string;
          "5": string;
          "6": string;
          "7": string;
        };
        green: { "1": string; "2": string; "3": string };
        pink: { "1": string; "2": string };
        red: { "1": string; "2": string; "3": string };
        yellow: { "1": string; "2": string };
      };
      spacing: { xs: string; sm: string; md: string; lg: string; xl: string };
      typography: {
        size: {
          title: { xs: string; sm: string; md: string; lg: string; xl: string };
          paragraph: { xs: string; sm: string; md: string; lg: string };
        };
        lineHeight: {
          title: { xs: string; sm: string; md: string; lg: string; xl: string };
          paragraph: { xs: string; sm: string; md: string; lg: string };
        };
        weight: { regular: number; bold: number };
      };
    };
  }
  interface ThemeOptions {
    shapeTheme?: string;
    tokens?: {
      colors?: {
        blue?: { "1": string; "2": string; "3": string; "4": string };
        gray?: {
          "1": string;
          "2": string;
          "3": string;
          "4": string;
          "5": string;
          "6": string;
          "7": string;
        };
        green?: { "1": string; "2": string; "3": string };
        pink?: { "1": string; "2": string };
        red?: { "1": string; "2": string; "3": string };
        yellow?: { "1": string; "2": string };
      };
      spacing?: { xs: string; sm: string; md: string; lg: string; xl: string };
      typography?: {
        size?: {
          title?: {
            xs: string;
            sm: string;
            md: string;
            lg: string;
            xl: string;
          };
          paragraph?: { xs: string; sm: string; md: string; lg: string };
        };
        lineHeight?: {
          title?: {
            xs: string;
            sm: string;
            md: string;
            lg: string;
            xl: string;
          };
          paragraph?: { xs: string; sm: string; md: string; lg: string };
        };
        weight?: { regular: number; bold: number };
      };
    };
  }
}
